import { render, staticRenderFns } from "./AllOrderReceiving.vue?vue&type=template&id=5f2f33c8&"
import script from "./AllOrderReceiving.vue?vue&type=script&lang=js&"
export * from "./AllOrderReceiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports